import { CollectionServer, GET, Model, POST, QueryDetail, QueryOrder, QueryParam, deleteInArray, errorCatch, updateInArray, useCollectionRef } from 'fennec-ui';
import React, { useState } from 'react';
import YImage from '../../../common/YImage';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import Icofont from 'react-icofont';
import confirmKey from '../../components/ConfirmKeyModal';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');
// 


export default function ParentEventSerii(props) {
    const [loading, setLoading] = useState(false);
    const { auth, object, item, sourceKey, create, collection, setCollection } = props;
    const cref = useCollectionRef()

    const filters = () => [
        {
            name: "kategoriyaUchastnikovVSerii.kategoriyaUchastnikov",
            filterType: "group",
            display: (o) => o.nazvanie,
            queryFilter: [
                QueryOrder("nazvanie", "ASC"),
            ],
            sort: true,
            filter: true,
            sorted: "ASC",
        },
        {
            name: "kategoriyaUchastnikovVSerii.tantsevalnayaDistsiplina",
            filterType: "group",
            display: (o) => o.nazvanie,
            queryFilter: [
                QueryOrder("nazvanie", "ASC"),
            ],
            sort: true,
            filter: true,
        },
        {
            name: "shablonRaspredeleniyaBallov",
            filterType: "group",
            display: (o) => o.name,
            queryFilter: [
                QueryOrder("name", "ASC"),
            ],
            sort: true,
            filter: true,
        },
    ];

    return (
        <CollectionServer
            auth={auth}
            name={"ParentEventSerii"}
            // source={`/api/query/parenteventserii`}
            contextFilters={() => [
                QueryParam("w-kategoriyaUchastnikovVSerii.seriya", object.ID)
            ]}
            collectionRef={cref}
            filters={filters}

            mode={"list"}
            render={(item, idx, { setCollection, setCollectionItem, update }) => {
                return (<div key={idx} style={{ width: "100%" }} className="ParentEventSerii">
                    <div style={{ flex: "auto", width: "100%", fontSize: "13px" }}>
                        <div style={{ fontWeight: "300", fontSize: "12px", fontStyle: "italic" }}>
                            <span style={{ fontWeight: "600", fontSize: "13px" }}>
                                {item?.kategoriyaUchastnikovVSerii?.tantsevalnayaDistsiplina?.nazvanie} - {item?.kategoriyaUchastnikovVSerii?.kategoriyaUchastnikov?.nazvanie}
                            </span>
                        </div>
                        <div>Шаблон: {item?.shablonRaspredeleniyaBallov?.name}, Приоритет: {item?.prioritet}</div>
                        <div>Мероприятие: {item?.meropriyatie?.nazvanieMeropriyatiya} - {dayjs(item?.meropriyatie?.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}, {item?.meropriyatie?.mestoProvedeniya?.name}</div>
                    </div>
                </div>)
            }}

            // customRender={(items, {
            //     collection,
            //     setCollection,
            //     setCollectionItem,
            //     removeCollectionItem,
            //     update
            // }) => (
            //     <div>
            //         {JSXMap(items, (o, oidx) => {
            //             return (<div>
            //                 <div key={oidx} auth={auth} item={o} idx={oidx} meropriyatie={object} setCollectionItem={setCollectionItem} />
            //             </div>)
            //         })}
            //     </div>
            // )}
            size={"small"}
            collectionActions={() => [{
                auth: auth,
                action: (values, unlock, close, { collection, setCollection }) => {
                    POST(auth, `/api/parent-event-serii/new`, values, ({ data }) => {
                        setCollection(updateInArray(collection, data));
                        close();
                    }, (err) => errorCatch(err, unlock)
                    );
                },
                title: "Добавить",
                form: Model,
                meta: [
                    {
                        label: "Мероприятие",
                        name: "meropriyatie",
                        type: "object",
                        mode: "dialog",
                        modal: { width: "700px" },
                        relation: {
                            uiFilter: () => [
                                {
                                    label: "Дата начала",
                                    name: "nachaloSorevnovaniya",
                                    type: "date",
                                    filterType: "range",
                                    sort: true,
                                    filter: true,

                                    sorted: "ASC",
                                    filtered: [dayjs().subtract(5, "days"), dayjs().add(1, "years")],
                                },
                                {   // Тип мероприятия
                                    label: "Тип мероприятия",
                                    name: "tipMeropriyatiya",
                                    filterType: "group",
                                    display: (o) => o.opisanie,
                                    sort: true,
                                    filter: true
                                },
                                {   // Уровень мероприятия
                                    label: "Уровень мероприятия",
                                    name: "urovenMeropriyatiya",
                                    filterType: "group",
                                    display: (o) => o.opisanie,
                                    sort: true,
                                    filter: true
                                },
                                {   // Место проведения
                                    label: "Место проведения",
                                    name: "mestoProvedeniya",
                                    filterType: "group",
                                    display: (o) => o.name,
                                    sort: true,
                                    filter: true
                                },
                            ],
                            displayString: (item) => {
                                return dayjs(item.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " + item.nazvanieMeropriyatiya + ", " + item?.mestoProvedeniya?.name
                            },
                            display: (item) => {
                                return (
                                    <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

                                        <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                                            <YImage item={item} width={32} hidePreview={true} />
                                        </div>

                                        <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                            <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                            <a href={`/fed/event/${item.ID}`}>
                                                <span style={{ fontWeight: "600" }}>{item.nazvanieMeropriyatiya}</span>
                                                </a>
                                            </div>
                                            <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                                <span style={{
                                                    marginRight: "5px",
                                                    borderRadius: "5px",
                                                    backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                                    color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                                                    fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",
                                                    fontSize: "12px",
                                                    boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                                    padding: "2px 4px"
                                                }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                                                <span>{item?.mestoProvedeniya?.name}</span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            },
                            reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                            type: "many-one",
                        },
                        queryFilter: [
                            QueryDetail("combobox"),
                            QueryOrder("nachaloSorevnovaniya", "DESC")
                        ]
                    },
                    {
                        label: "Категория участников в серии",
                        name: "kategoriyaUchastnikovVSerii",
                        type: "object",
                        relation: {
                            display: (item) => {
                                return item.tantsevalnayaDistsiplina.nazvanie + " - " + item.kategoriyaUchastnikov.nazvanie
                            },
                            reference: { object: "KategoriiUchastnikovSerii", property: "ID" },
                            type: "many-one",
                        },
                        queryFilter: [
                            QueryDetail("model"),
                            QueryOrder("tantsevalnayaDistsiplina.nazvanie", "ASC"),
                            QueryParam("w-seriya", object.ID)
                        ]
                    },
                    {
                        label: "Шаблон распределения баллов",
                        name: "shablonRaspredeleniyaBallov",
                        type: "object",
                        relation: {
                            display: (item) => {
                                return item.name
                            },
                            reference: { object: "PointsTemplate", property: "ID" },
                            type: "many-one",
                        },
                        queryFilter: [
                            QueryOrder("name", "ASC"),
                        ],
                    },
                    {
                        label: "Приоритет",
                        name: "prioritet",
                        type: "int",
                    }
                ],
            }]}
            modelActions={(item) => [
                {
                    auth: auth,
                    action: (values, unlock, close, { collection, setCollection }) => {
                        POST(auth, `/api/parent-event-serii/update`, { ...values, ID: item.ID }, ({ data }) => {
                            setCollection(updateInArray(collection, data));
                            close();
                        }, (err) => errorCatch(err, unlock)
                        );
                    },
                    title: "Изменить",
                    form: Model,
                    meta: [
                        {
                            label: "Мероприятие",
                            name: "meropriyatie",
                            type: "object",
                            mode: "dialog",
                            modal: { width: "700px" },
                            relation: {
                                uiFilter: () => [
                                    {
                                        label: "Дата начала",
                                        name: "nachaloSorevnovaniya",
                                        type: "date",
                                        filterType: "range",
                                        sort: true,
                                        filter: true,

                                        sorted: "ASC",
                                        filtered: [dayjs().subtract(5, "days"), dayjs().add(1, "years")],
                                    },
                                    {   // Тип мероприятия
                                        label: "Тип мероприятия",
                                        name: "tipMeropriyatiya",
                                        filterType: "group",
                                        display: (o) => o.opisanie,
                                        sort: true,
                                        filter: true
                                    },
                                    {   // Уровень мероприятия
                                        label: "Уровень мероприятия",
                                        name: "urovenMeropriyatiya",
                                        filterType: "group",
                                        display: (o) => o.opisanie,
                                        sort: true,
                                        filter: true
                                    },
                                    {   // Место проведения
                                        label: "Место проведения",
                                        name: "mestoProvedeniya",
                                        filterType: "group",
                                        display: (o) => o.name,
                                        sort: true,
                                        filter: true
                                    },
                                ],
                                displayString: (item) => {
                                    return dayjs(item.nachaloSorevnovaniya).format("DD.MM.YYYY") + " - " + item.nazvanieMeropriyatiya + ", " + item?.mestoProvedeniya?.name
                                },
                                display: (item) => {
                                    return (
                                        <div key={item.ID} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", padding: "2px 5px", marginBottom: "5px" }}>

                                            <div style={{ width: "32px", height: "32px", overflow: "hidden", borderRadius: "4px" }}>
                                                <YImage item={item} width={32} hidePreview={true} />
                                            </div>

                                            <div style={{ flex: "auto", paddingLeft: "7px" }}>
                                                <div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "14px" }}>
                                                <a href={`/fed/event/${item.ID}`}>
                                                    <span style={{ fontWeight: "600" }}>{item.nazvanieMeropriyatiya}</span>
                                                    </a>
                                                </div>
                                                <div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px", fontSize: "12px" }}>
                                                    <span style={{
                                                        marginRight: "5px",
                                                        borderRadius: "5px",

                                                        // backgroundColor: "#f6214b",
                                                        // color: "white",

                                                        backgroundColor: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "#eaeaea" : "#f6214b",
                                                        color: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "black" : "white",
                                                        fontWeight: (dayjs().isAfter(item.okonchanieSorevnovaniya)) ? "400" : "600",

                                                        fontSize: "12px",


                                                        boxShadow: "rgba(34, 60, 80, 0.3) 0px 3px 1px -2px",
                                                        padding: "2px 4px"
                                                    }}>{dayjs(item.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}</span>
                                                    <span>{item?.mestoProvedeniya?.name}</span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                },
                                reference: { object: "Meropriyatiya", property: "ID", source: "/api/meropriyatiya/list/com" },
                                type: "many-one",
                            },
                            queryFilter: [
                                QueryDetail("combobox"),
                                QueryOrder("nachaloSorevnovaniya", "DESC")
                            ]
                        },
                        {
                            label: "Категория участников в серии",
                            name: "kategoriyaUchastnikovVSerii",
                            type: "object",
                            relation: {
                                display: (item) => {
                                    return item.tantsevalnayaDistsiplina.nazvanie + " - " + item.kategoriyaUchastnikov.nazvanie
                                },
                                reference: { object: "KategoriiUchastnikovSerii", property: "ID" },
                                type: "many-one",
                            },
                            queryFilter: [
                                QueryDetail("model"),
                                QueryOrder("tantsevalnayaDistsiplina.nazvanie", "ASC"),
                                QueryParam("w-seriya", object.ID)
                            ]
                        },
                        {
                            label: "Шаблон распределения баллов",
                            name: "shablonRaspredeleniyaBallov",
                            type: "object",
                            relation: {
                                display: (item) => {
                                    return item.name
                                },
                                reference: { object: "PointsTemplate", property: "ID" },
                                type: "many-one",
                            },
                            queryFilter: [
                                QueryOrder("name", "ASC"),
                            ],
                        },
                        {
                            label: "Приоритет",
                            name: "prioritet",
                            type: "int",
                        }
                    ],
                },
                {
                    auth: auth,
                    title: <span style={{ color: "red" }}>Удалить</span>,
                    action: (values, unlock, close, { collection, setCollection }) => {
                        confirmKey({
                            pass: '123',
                            title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить вышестоящее мероприятие</span>,
                            icon: undefined,
                            content: <span>Вы действительно хотите удалить вышестоящее мероприятие по указанной категории?</span>,
                            okText: 'Удалить',
                            cancelText: 'Отмена',
                            onOk() {
                                return new Promise((resolve, reject) => {
                                    GET(auth, '/api/parent-event-serii/delete/' + item.ID,
                                        ({ data }) => {
                                            setCollection(deleteInArray(collection, item));
                                            resolve(data);
                                        }, (err) => errorCatch(err, reject));
                                }).catch(() => { });
                            },
                            onCancel() {
                            },
                        })

                    }
                }]}
        />
    );
}
